(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Livewire",
            {
                url: "/Livewire",
                component: "livewire",
                PageTitle: "LiveWire",
                requiredPermissions: "LiveWire:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("livewire",
    {
        templateUrl: "App/Resources/Livewire/Livewire.html",
        controller: livewireCtrl,
        bindings: {
            states: "<"
        }
    });

    livewireCtrl.$inject = ["$filter", "eligibilityFormDialog", "surveys", "eligibilityFormApi", "wistiaApi", "permissionService", "amplitudeService"];


    function livewireCtrl($filter, eligibilityFormDialog, surveys, eligibilityFormApi, wistiaApi, permissionService, amplitudeService) {

        var $ctrl = this;                   

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };

        surveys.then(function (s) {
            eligibilityFormApi.isEnrolled(s.livewireId).then(function (response) {
                $ctrl.submitted = response;
            });
        });

        $ctrl.loadResources = function () {
        
            $ctrl.loadingAssets = true;          
            wistiaApi.getLiveWireAssets().then(function (response) {      
                
                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("unique")(projectMedias, "section");
                ng.forEach(uniqueMedias, function (value, key) {
                    var newAsset =
                    {
                        Title: value.section,
                        Active: uniqueMedias.length > 1 ? true : false,
                        Medias: ($filter("filter")(projectMedias, { section: value.section }))
                    }
                    $ctrl.Assets.push(newAsset);
                });

            }).then($ctrl.loadingAssets = false);           
        }


        $ctrl.closeOtherAssets = function (asset) {
            ng.forEach($ctrl.Assets, function (a, key) {
                if (a.ID !== asset.ID)
                    a.Active = false;
            });
        }

        /*  Open the Enrollment Form  */
        $ctrl.openDialog = function (event) {
            surveys.then(function (s) {
                eligibilityFormDialog.open(event, s.livewireId).then(function (obj) {
                    ng.extend($ctrl, obj);
                });
            });
        }

        if (permissionService.hasOnePermission("LiveWire:Access")) {
            $ctrl.loadResources();
        }     
    }
})(window.app, window.angular); // jshint ignore:line